import React, { useState, useCallback } from 'react';
import { Button } from '@mui/material';
import { SearchRounded as SearchIcon } from '@mui/icons-material';

import { useKeywordsData } from '../../../hooks/useKeywordsData';
import { useCrossScraperKeywords } from '../../../hooks/useCrossScraperKeywords';
import AddKeywordDialog from '../../AddKeywordDialog';
import { createColumns } from '../../../utils/mabScrapingColumns';
import ScraperTablePage from './ScraperTablePage';
import CrossScraperKeywordsDialog from './CrossScraperKeywordsDialog';

export default function KeywordScrapers({ projects }) {
  const {
    rows, loading, error, setError, clearError,
    updateKeyword, deleteKeyword, refetch,
  } = useKeywordsData();

  const { massAdd } = useCrossScraperKeywords();

  const [crossScraperOpen, setCrossScraperOpen] = useState(false);
  const [addDialogOpen, setAddDialogOpen] = useState(false);
  const [addDialogDefaultProject, setAddDialogDefaultProject] = useState('');

  const handleMutationComplete = useCallback(() => {
    refetch({ silent: true });
  }, [refetch]);

  const handleAddClick = useCallback((selectedProject) => {
    setAddDialogDefaultProject(selectedProject);
    setAddDialogOpen(true);
  }, []);

  const handleAddSave = useCallback(async (keywords, projectNames) => {
    const result = await massAdd(keywords, projectNames);
    refetch({ silent: true });
    return result;
  }, [massAdd, refetch]);

  return (
    <>
      <ScraperTablePage
        projects={projects}
        rows={rows}
        loading={loading}
        error={error}
        setError={setError}
        clearError={clearError}
        updateItem={updateKeyword}
        deleteItem={deleteKeyword}
        editableFields={['keyword']}
        createColumnsFn={createColumns}
        entityName="keyword"
        itemLabelField="keyword"
        selectLabelId="kw-project-select"
        addButtonLabel="Add Keyword"
        AddDialog={AddKeywordDialog}
        onAddClick={handleAddClick}
        extraToolbarActions={
          <Button
            variant="outlined"
            startIcon={<SearchIcon />}
            onClick={() => setCrossScraperOpen(true)}
            sx={{
              textTransform: 'none',
              fontWeight: 600,
              borderRadius: 2,
            }}
          >
            Search Scrapers
          </Button>
        }
      />

      <AddKeywordDialog
        open={addDialogOpen}
        onClose={() => setAddDialogOpen(false)}
        onSave={handleAddSave}
        keywordProjects={projects}
        defaultProject={addDialogDefaultProject}
      />

      <CrossScraperKeywordsDialog
        open={crossScraperOpen}
        onClose={() => setCrossScraperOpen(false)}
        onMutationComplete={handleMutationComplete}
      />
    </>
  );
}
